import { useState, lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Sidebar from './Sidebar';
import Header from './Header';
const InstallPrompt = lazy(() => import('../ui/InstallPrompt'));
const CopilotPanel = lazy(() => import('../copilot/CopilotPanel'));
import MobileNav from './MobileNav';
import GlobalTableSearch from '../ui/GlobalTableSearch';
import { Sparkles } from 'lucide-react';

export default function Layout() {
  const { t } = useTranslation();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [desktopCollapsed, setDesktopCollapsed] = useState(false);
  const [copilotOpen, setCopilotOpen] = useState(false);

  return (
    <div className="flex h-screen bg-slate-50 dark:bg-slate-950 overflow-hidden">
      <Sidebar
        mobileOpen={mobileOpen}
        onMobileClose={() => setMobileOpen(false)}
        desktopCollapsed={desktopCollapsed}
        onNavClick={() => {
          setMobileOpen(false);
          setDesktopCollapsed(true);
        }}
      />
      <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
        <Header
          onMenuClick={() => setMobileOpen(true)}
          desktopCollapsed={desktopCollapsed}
          onToggleSidebar={() => setDesktopCollapsed(v => !v)}
        />
        <main className="flex-1 overflow-auto bg-slate-50 dark:bg-slate-950 p-4 lg:p-6 pb-20 sm:pb-6">
          <GlobalTableSearch />
          <div data-page-content>
            <Outlet />
          </div>
        </main>
      </div>
      <MobileNav />
      <Suspense fallback={null}><InstallPrompt /></Suspense>

      {/* Copilot toggle button */}
      {!copilotOpen && (
        <button
          onClick={() => setCopilotOpen(true)}
          className="fixed bottom-6 end-6 z-50 w-12 h-12 bg-purple-600 hover:bg-purple-500 text-white rounded-full shadow-lg flex items-center justify-center transition-all hover:scale-105 sm:bottom-6"
          title={t('layout_open_copilot', { defaultValue: 'Open AI Copilot' })}
        >
          <Sparkles className="w-5 h-5" />
        </button>
      )}

      {/* Copilot slide-out panel */}
      <Suspense fallback={null}>
        <CopilotPanel isOpen={copilotOpen} onClose={() => setCopilotOpen(false)} />
      </Suspense>
    </div>
  );
}
